<template>
    <div :class="['', padding? 'flex justify-center items-center h-32 pt-60': 'flex justify-center items-center h-32']">
    <svg class="animate-spin h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
    </div>
    <h2 :class="['', padding? 'text-xl text-white font-bold pt-10': 'text-xl text-white font-bold']" style="display: flex; justify-content: space-around;" >{{this.loadingname}}</h2>
</template>

<script>
export default {
  name: "loadingSpinner",
  props: {
    loadingname: {
      type: String,
      required: false,
      default: 'Loading'
    },
    padding: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data(){
    return {
        requests: [],
        modifyId: null,
    }
  }}
</script>
